const formNames = {
  address_line_1: "#{form_name_prefix}[address_line_1]",
  city: "#{form_name_prefix}[city]",
  country: "#{form_name_prefix}[country]",
  google_place_id: "#{form_name_prefix}[google_place_id]",
  post_town: "#{form_name_prefix}[post_town]",
  postcode: "#{form_name_prefix}[postcode]",
  state: "#{form_name_prefix}[state]",
  street_address: "#{form_name_prefix}[street_address]",
  street_number: "#{form_name_prefix}[street_number]",
  suburb: "#{form_name_prefix}[suburb]",
}

export default formNames